import { render } from "./footerSeccion.vue?vue&type=template&id=5a9518a0&scoped=true"
const script = {}

import "./footerSeccion.vue?vue&type=style&index=0&id=5a9518a0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9518a0"]])

export default __exports__